// app/javascript/material_evaluations/rows.js

export function addMaterialRow(index, materialOptions, materialMap, materialsContainer, materialId = "", qty = "", unitPrice = "", supplier = "") {
  const row = document.createElement("div");
  row.className = "row mb-2 material-row";
  row.innerHTML = `
    <div class="col-md-3 mb-1">
      <select name="material_evaluation[material_items_attributes][${index}][material_id]" 
              class="form-select material-select">
        ${materialOptions}
      </select>
    </div>
    <div class="col-md-2">
      <input type="number" name="material_evaluation[material_items_attributes][${index}][qty]" 
             value="${qty}" class="form-control qty-input" placeholder="Qty">
    </div>
    <div class="col-md-2">
      <input type="text" class="form-control uom-input" value="" readonly>
    </div>
    <div class="col-md-2">
      <input type="number" name="material_evaluation[material_items_attributes][${index}][unit_price]" 
             value="${unitPrice}" class="form-control unit-price-input" placeholder="Unit Price">
    </div>
    <div class="col-md-2">
      <input type="text" class="form-control total-price-input" 
             value="${numWithCommas(qty * unitPrice)}" placeholder="Total Price" readonly>
    </div>
    <div class="col-md-3">
      <input type="text" name="material_evaluation[material_items_attributes][${index}][supplier]" 
             value="${supplier}" class="form-control" placeholder="Supplier">
    </div>
    <div class="col-md-2">
      <button type="button" class="btn btn-sm btn-danger removeRowBtn">Remove</button>
    </div>
    <div class="col-12"><hr class="my-2"></div>
  `;
  materialsContainer.appendChild(row);

  const select = row.querySelector("select");
  const uomInput = row.querySelector(".uom-input");

  if (materialId) {
    select.value = materialId;
    uomInput.value = materialMap[materialId] || "";
  }

  select.addEventListener("change", () => {
    const selectedId = select.value;
    uomInput.value = materialMap[selectedId] || "";
  });
}

export function addMachineRow(index, machineOptions, machinesContainer, machineId = "", hrs = "") {
  const row = document.createElement("div");
  row.className = "row mb-2";
  row.innerHTML = `
    <div class="col-md-6">
      <select name="material_evaluation[machine_items_attributes][${index}][machine_id]" class="form-select">
        ${machineOptions}
      </select>
    </div>
    <div class="col-md-4">
      <input type="number" name="material_evaluation[machine_items_attributes][${index}][hrs]" 
             value="${hrs}" class="form-control" placeholder="Hours">
    </div>
    <div class="col-md-2">
      <button type="button" class="btn btn-sm btn-danger removeRowBtn">Remove</button>
    </div>
  `;
  machinesContainer.appendChild(row);
  if (machineId) row.querySelector("select").value = machineId;
}
